import React from "react";
import { MapPin, Clock, Phone, Mail } from "lucide-react";

const PASTOR_IMG = "https://images.pexels.com/photos/8815003/pexels-photo-8815003.jpeg";

export default function AboutSection({ info }) {
  return (
    <section id="apropos" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 text-gold-dark text-xs tracking-[0.3em] uppercase mb-4">
            À propos
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-deepblue-900 font-semibold leading-tight">
            Notre communauté vous accueille
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* Pastor */}
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-12 gap-6">
              <div className="sm:col-span-5">
                <div className="relative rounded-2xl overflow-hidden aspect-[3/4] shadow-xl">
                  <img src={PASTOR_IMG} alt={info?.pastor_name || "Pasteur"} className="w-full h-full object-cover" />
                  <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-deepblue-900 to-transparent">
                    <div className="text-white font-serif text-lg">{info?.pastor_name}</div>
                    <div className="text-gold text-xs tracking-widest uppercase">Pasteur principal</div>
                  </div>
                </div>
              </div>
              <div className="sm:col-span-7 flex flex-col justify-center">
                <div className="text-6xl font-serif text-gold leading-none">"</div>
                <p className="mt-2 font-serif text-2xl text-deepblue-900 leading-relaxed">
                  {info?.pastor_message}
                </p>
                <div className="mt-6 text-sm text-slate-500 tracking-wider uppercase">— Mot du pasteur</div>
              </div>
            </div>
          </div>

          {/* Info panel */}
          <div className="lg:col-span-5 space-y-6">
            <div className="rounded-2xl p-8 bg-deepblue-900 text-white relative overflow-hidden">
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-gold/20 blur-3xl" />
              <div className="text-gold text-xs tracking-[0.3em] uppercase mb-4 flex items-center gap-2">
                <Clock className="w-3.5 h-3.5" /> Programme hebdomadaire
              </div>
              <ul className="space-y-4 relative">
                {(info?.weekly_schedule || []).map((s, i) => (
                  <li key={i} className="flex items-baseline justify-between gap-4 pb-4 border-b border-white/10 last:border-b-0 last:pb-0">
                    <div>
                      <div className="font-serif text-lg">{s.title}</div>
                      <div className="text-white/60 text-sm">{s.day}</div>
                    </div>
                    <div className="text-gold font-semibold">{s.time}</div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl p-6 border border-slate-200 bg-white space-y-4">
              <InfoRow icon={<MapPin className="w-4 h-4" />} label="Adresse" value={info?.address} />
              <InfoRow icon={<Phone className="w-4 h-4" />} label="Téléphone" value={info?.phone} />
              <InfoRow icon={<Mail className="w-4 h-4" />} label="Email" value={info?.email} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoRow({ icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <div className="mt-0.5 w-8 h-8 rounded-full bg-gold/10 text-gold-dark flex items-center justify-center flex-shrink-0">
        {icon}
      </div>
      <div className="min-w-0">
        <div className="text-[10px] uppercase tracking-widest text-slate-400">{label}</div>
        <div className="text-deepblue-900 font-medium truncate">{value}</div>
      </div>
    </div>
  );
}
